import * as React from "react"

const SvgWhiteHeaderSvg = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={396}
    height={190}
    viewBox="0 0 396 190"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      d="M0 0h301c52.467 0 95 41.98 95 93.765S353.467 190 301 190l-301-.077C.691 189.8 1.05.306 0 0Z"
      fill="#fff"
    />
  </svg>
)

export default SvgWhiteHeaderSvg
